import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = { class: "card-header cursor-pointer p-9" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "fw-bolder m-0 mx-3" }
const _hoisted_7 = { class: "card-body p-9" }
const _hoisted_8 = { class: "row mb-7 mt-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Name", -1)
const _hoisted_10 = { class: "col-lg-8" }
const _hoisted_11 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_12 = { class: "row mb-7" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Email", -1)
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fw-bold fs-6" }
const _hoisted_16 = { class: "row mb-7" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Telephone ", -1)
const _hoisted_18 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_19 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_20 = { class: "row mb-7" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Job Title", -1)
const _hoisted_22 = { class: "col-lg-8" }
const _hoisted_23 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_24 = { class: "row mb-7" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " LinkedIn Profile ", -1)
const _hoisted_26 = { class: "col-lg-8" }
const _hoisted_27 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_28 = ["href"]
const _hoisted_29 = { class: "row mb-7" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Business Clicks", -1)
const _hoisted_31 = { class: "col-lg-8" }
const _hoisted_32 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_33 = { class: "row mb-7" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Business Shows", -1)
const _hoisted_35 = { class: "col-lg-8" }
const _hoisted_36 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_37 = { class: "row mb-7" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Total Connections", -1)
const _hoisted_39 = { class: "col-lg-8" }
const _hoisted_40 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_41 = { class: "card mb-5 mb-xl-10" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0",
  style: {"min-height":"60px !important"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Businesses")
  ])
], -1)
const _hoisted_43 = { class: "container-fluid p-0" }
const _hoisted_44 = { class: "row m-3 g-0" }
const _hoisted_45 = { class: "col-12 order-xl-first order-last" }
const _hoisted_46 = {
  class: "content",
  style: {"background-color":"#1b283f"}
}
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-sm-4 col-12 order-sm-first order-last text-center offset-sm-1" }
const _hoisted_49 = ["src"]
const _hoisted_50 = { class: "col-sm-4 col-12 order-sm-last order-first text-white text-center my-sm-auto mt-3 offset-sm-1" }
const _hoisted_51 = { style: {"color":"white !important"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.founder?.profileImage ?? require('@/assets/img/blank.png'),
                alt: "image"
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.founder?.firstName) + " " + _toDisplayString(_ctx.founder?.lastName), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.founder?.firstName) + " " + _toDisplayString(_ctx.founder?.lastName), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.founder?.email), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.founder?.telephone ?? "None"), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.founder?.jobTitle ?? "None"), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("span", _hoisted_27, [
                _createElementVNode("a", {
                  href: _ctx.op.get(_ctx.founder, 'linkedInProfileUrl', '#'),
                  target: "_blank"
                }, _toDisplayString(_ctx.op.get(_ctx.founder, "linkedInProfileUrl", "None") ?? "None"), 9, _hoisted_28)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.founder?.founderBusinessClicks ?? 0), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.founder?.founderBusinessShows ?? 0), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.founder?.founderTotalConnections ?? 0), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _hoisted_42,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.founder.founderBusiness, (business) => {
        return (_openBlock(), _createElementBlock("div", {
          key: business.id
        }, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", null, [
                        _createElementVNode("img", {
                          class: "rounded-circle my-2",
                          src: `${business.logo ?? '/media/avatars/blank.png'}`,
                          style: {"border":"3px solid white","width":"120px","height":"118px","object-fit":"cover"}
                        }, null, 8, _hoisted_49)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("h3", _hoisted_51, _toDisplayString(business.name), 1),
                      _createElementVNode("p", null, _toDisplayString(business.summary), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      }), 128))
    ])
  ], 64))
}